import { useEffect } from "react";
import { matchPath, useHistory } from "react-router-dom";
import { DRAWER_PATHS } from "common/Home/useDrawers.tsx";

const useHistoryTracker = () => {
  const history = useHistory();

  const processStack = (stack: string[]) => {
    const updatedStack: string[] = [];
    let prevPath: string | undefined;
    [...stack].reverse().forEach((path) => {
      if (path !== prevPath) {
        updatedStack.push(path);
      }
      prevPath = path;
    });
    historyStack = updatedStack.reverse();
  };

  const isDrawerPath = (locationPath: string) => {
    return DRAWER_PATHS.some((drawerPath) => {
      return matchPath(locationPath, {
        path: drawerPath,
        exact: true,
        strict: false,
      });
    });
  };

  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      const isDrawer = isDrawerPath(location.pathname);
      if (isDrawer || (location.state as any)?.isBackButton) return;
      const stack = [...historyStack];
      if (action === "PUSH") {
        stack.push(location.pathname);
      } else if (action === "POP") {
        stack.pop();
      } else if (action === "REPLACE") {
        if (stack.length) {
          stack[stack.length - 1] = location.pathname;
        } else {
          stack.push(location.pathname);
        }
      }
      processStack(stack);
    });
    return () => {
      unlisten();
    };
  }, [history]);
};

export default useHistoryTracker;

export let historyStack: string[] = [];
